import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bubble-4, message, chat"} maskId="square-filled-radius-0-stroke-1-IconBubble4"><path d="M21.002 3V20H7.64535L3.00195 22.9021V3H21.002Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBubble4;
